module.exports = __webpack_public_path__ + "img/86.91befc8b.png";